// extracted by mini-css-extract-plugin
module.exports = {"appName":"AppCard_appName__22tKH","appDescription":"AppCard_appDescription__u-6jX"};